import { RoutesStateMap } from '@app-store/reducers/routes.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRoutesState = createFeatureSelector<RoutesStateMap>('routes');

export const selectComponentRouteState = (props: {key: string}) =>
	createSelector(selectRoutesState, (state: RoutesStateMap) => state.get(props.key));
